import React from 'react';
import { signatureHtml } from './emailSignatureModel.js';

/** Render the same conservative HTML used by the clipboard operation. */
export default function SignaturePreview({ template, values, previewRef }) {
    return <div ref={previewRef} className='email-signature-preview' dangerouslySetInnerHTML={{ __html: signatureHtml(template, values) }} />;
}
